// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-full-with-text/image-full-with-text.component.scss
// module id = 372
// module chunks = 0